import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaPlus, FaMinus, FaSync } from 'react-icons/fa'; // Import FaSync icon
import ButtonIcon from '../components/ButtonIcon';
import BlogCreateForm from '../components/BlogCreateForm';
import BlogTable from '../components/BlogTable';
import API_URL from '../../config';
import DeletedDataList from '../components/DeletedDataList';

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  margin: 6rem auto;
`;

const AdminPanel = () => {
    const [blogs, setBlogs] = useState([]);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        getAllBlogs();
    }, []);

    const getAllBlogs = async () => {
        try {
            const response = await fetch(`${API_URL}/get-all-blogs`);
            if (!response.ok) {
                throw new Error('Failed to fetch blogs');
            }
            const data = await response.json();
            setBlogs(data);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    };

    const handleSaveBlog = async (editedBlog) => {
        try {
            const method = editedBlog.id ? 'PUT' : 'POST';
            const url = editedBlog.id ? `${API_URL}/update-blog/${editedBlog.id}` : `${API_URL}/create-blog`;

            const response = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(editedBlog),
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to ${editedBlog.id ? 'update' : 'create'} blog: ${response.status} - ${errorText}`);
            }

            getAllBlogs();
            setShowForm(false); // Hide the form after successful update or creation
        } catch (error) {
            console.error('Error saving blog:', error);
        }
    };

    return (
        <Container>
            <h1>Admin Page</h1>
            <ButtonIcon onClick={() => setShowForm(!showForm)}>
                {showForm ? <FaMinus /> : <FaPlus />}
            </ButtonIcon>
            {showForm && <BlogCreateForm setShowForm={setShowForm} getAllBlogs={getAllBlogs} onSave={handleSaveBlog} />}
            <ButtonIcon onClick={getAllBlogs}> {/* Add a refresh button */}
                <FaSync />
            </ButtonIcon>
            <BlogTable blogs={blogs} getAllBlogs={getAllBlogs} />
            <DeletedDataList />
        </Container>
    );
};

export default AdminPanel;
